import { SVGProps } from "react";

export const JiraProductDiscoveryMarkBrandV2 = ({
    width = "100%",
    height = "100%"
}: Pick<SVGProps<SVGSVGElement>, "height" | "width">) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="Container">
            <path
                id="Vector"
                d="M18.9987 16.2795C18.9987 16.2795 19.0181 16.6595 19.0181 17.1842C19.0181 19.1389 17.4334 20.7235 15.4787 20.7235C13.5241 20.7235 11.9394 19.1389 11.9394 17.1842C11.9394 15.2295 13.5241 13.6449 15.4787 13.6449C16.0034 13.6449 16.3254 13.6642 16.3254 13.6642V6.74687C16.0461 6.72421 15.7641 6.71021 15.4787 6.71021C9.69207 6.71021 5.00073 11.4015 5.00073 17.1882C5.00073 22.9749 9.69207 27.6662 15.4787 27.6662C21.2654 27.6662 25.9567 22.9749 25.9567 17.1882C25.9567 16.8549 25.9507 16.6235 25.9234 16.2802H18.9987V16.2795Z"
                fill="#1868DB"
            />
            <path
                id="Vector_2"
                d="M17.9234 5.67621C20.8314 6.46221 23.7394 6.46221 26.6474 5.67621C26.8574 5.61954 27.046 5.80821 26.9894 6.01821C26.2034 8.92621 26.2034 11.8342 26.9894 14.7422C27.046 14.9522 26.8574 15.1409 26.6474 15.0842C23.7394 14.2982 20.8314 14.2982 17.9234 15.0842C17.7134 15.1409 17.5247 14.9522 17.5814 14.7422C18.3674 11.8342 18.3674 8.92621 17.5814 6.01821C17.5247 5.80821 17.7134 5.61954 17.9234 5.67621Z"
                fill="#1868DB"
            />
        </g>
    </svg>
);
